import { Button } from '@chakra-ui/button';
import { Flex, Text } from '@chakra-ui/layout';
import { MintModalProps } from 'components/modals/MintModal';
import { ModalType } from 'components/modals/types';
import { FaLock } from 'react-icons/fa';
import { useModal } from 'store/modals';
import { Crucible } from 'types';

type Props = {
  crucible: Crucible;
  readOnly: boolean;
};

const CrucibleMembership: React.FC<Props> = ({ crucible, readOnly }) => {
  const { openModal } = useModal();

  return (
    <Flex flexDir='column' alignItems='center' py={6}>
      <FaLock fontSize='32px' />
      <Text mt={2}>No Artwork available for this Crucible</Text>
      {!readOnly && (
        <Button mt={4} onClick={() => {
          openModal(ModalType.mint, {
            type: 'pro',
            upgrade: {
              crucibleAddress: crucible.id
            }
          } as MintModalProps)
        }}>
          Upgrade
        </Button>
      )}
    </Flex>
  );
};

export default CrucibleMembership;
